module.exports = __webpack_public_path__ + "img/IT0000205603300.5861833e.png";